import { QuoteListItem } from '../../components/QuoteListItem'

export const QuoteSignatureRequestFailedListItem = (props: {
  taskId: string
  isSelected: boolean
  hideUnreadIndicator?: boolean
  onClick: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void
}) => <QuoteListItem {...props} description="Signature request failed" />
